import styled from 'styled-components';

import theme from '$/assets/theme';

const SuccessMessage = styled.span`
  font-size: 14px;
  color: ${theme.colors.brandGreen};
`;

export default SuccessMessage;
